export const facturacion = {
    text1: "طريقة الدفع",
    text2: "بطاقة ائتمان",
    text3: "لا توجد طرق دفع مسجّلة",
    text4: "تعديل طريقة الدفع",
    text5: "إضافة طريقة دفع",
    text6: "أضف طريقة دفع",
    text7: "تحديث طريقة دفع",
    text8: "سجّل أو حدّث طريقة الدفع التي ستُخصم منها الرسوم الشهرية.",
    text9: "رقم البطاقة:",
    text10: "الانتهاء",
    text11: "CVC",
    text12: "حفظ البطاقة",
    text13: "رقم غير صالح",
    text14: "غير صالح",
    text15: "رمز CVC غير صالح.",
    text16: "حدث خطأ ما",
    text17: "الاستهلاك",
    text18: "الفواتير الصادرة",
    text19: "من - إلى",
    text20: "المعرّف",
    text21: "القيمة",
    text22: "الجهة المُصدِرة للفاتورة",
    text23: "BIG NERDS COMPANY L.L.C.",
    text24: "تاريخ الإصدار",
    text25: "الحالة",
    text26: "تنزيل الفاتورة",
    text27: "جارٍ إنشاء الفاتورة ...",
    text28: "أوشكنا على الانتهاء، يُرجى الانتظار...",
    text29: "جارٍ التحميل ...",
    text30: "عذرًا، تعذّر إنشاء الفاتورة",
    text31: "هل أنت متأكد من حذف طريقة الدفع؟",
    text32: "ستفقد بياناتك المحفوظة",
    text33: "حذف الطريقة",
    text34: "إلغاء",

    // Corrections
    p1: "الاشتراك",
    p2: "اشتراكك",
    p3: "مجاني",
    p4: "مخصّص",
    p5: "ليس لديك اشتراك نشط. لنفعل شيئًا حيال ذلك!",
    p6: "ينتهي في:",
    p7: "اختر خطة",
    p8: "ترقية",
    p9: "عدد العقارات",
    p10: "لكل عقار",
    p11: "إدارة الاشتراك",
    p12: "إعدادات الدفع",
    p13: "ينتهي في:",
    p14: "تعديل",
    p15: "التجديد التلقائي",
    p16: "مفعّل",
    p17: "الدفعة التالية مجدولة في",
    p18: "الفواتير والإيصالات",
    p19: "مخصّص",
    p20: "عرض الفاتورة",
    p21: "تنزيل الفاتورة",
    p22: "لـ",

    p23: "شهري",
    p24: "سنوي",
    p25: "نهديك شهرين مجانًا.",
    p26: "نوع الاشتراك",


    p27: "شقة سياحية",
    p28: "فندق - نُزُل",
    p29: "مخيّم",
    p30: "فيلا",


    p31: `يستند "<strong>العقار</strong>" إلى المنازل أو الشقق الفردية. أما في "<strong>الشقق الفندقية</strong>" فتُحتسب كل شقة عقارًا واحدًا`,
    p32: `تُحتسب
    <strong>الغرف</strong> في حالة الفنادق، والأسِرّة في حالة النُّزُل،
    و<strong>الأشخاص </strong> في حالة التخييم.

    <br />
    <strong>على سبيل المثال:</strong> نُزُل به 4 غرف و20 سريرًا يُحتسب
    20 وحدة إقامة`,

    p33: `PREMIUM`,
    p34: `شهر`,
    p35: `غرفة`,
    p36: `شقة`,
    p37: `تفاصيل الخطة`,
    p38: `تسجيل الوصول في الموقع عبر QR`,
    p39: `تسجيل الوصول برابط مُرسَل مسبقًا`,
    p40: `رسالة ترحيب بالبريد الإلكتروني`,
    p41: `توقيع السياسات بالقياسات الحيوية`,
    p42: `ماسح الهوية وجواز السفر`,
    p43: `تخزين سحابي غير محدود`,
    p44: `متجر البيع المتقاطع`,
    p45: `إرسال التقارير تلقائيًا إلى الجهات المختصة`,
    p46: `مزامنة الحجوزات مع PSM`,
    p47: `تحديث الاشتراك`,
    p48: `متابعة`,
    p49: `لكل`,

    p50: `اختر خدمات إضافية لخطتك`,
    p51: `موصى به`,
    p52: `WhatsApp`,
    p53: `ندعو نزلاءك إلى تسجيل الوصول عبر WhatsApp بجدولة مسبقة قبل وصولهم إلى وحدة إقامتك.`,
    p54: `شقة`,
    p55: `فيلا`,
    p56: `مكان`,
    p57: `غرفة`,
    p58: `الفرق في استخدام WhatsApp`,
    p59: `استخدام WhatsApp الخاص بنا`,
    p60: `عند استخدام خدمة WhatsApp لدينا، سيكون اسم مُرسِل الرسائل إلى نزلائك هو WACheckin. نتولّى نحن إدارة الرسائل لضمان تواصل فعّال مع نزلائك.`,
    p61: `إذا استخدمت خدمتنا برقم WhatsApp الخاص بك، فسيكون اسم المُرسِل هو اسمك على WhatsApp، ويمكنك الحصول على شارة التوثيق. وتخضع تكلفة الإرسال لاستهلاك حسابك على WhatsApp Business لدى Meta.`,
    p62: `استخدام WhatsApp Business الخاص بك`,
    p63: `التقييمات`,
    p64: `اغتنم هذه الفرصة لتحسين تجربة نزلائك والحصول على مزيد من التقييمات الإيجابية!`,
    p65: `المزايا`,
    p66: `عند تسجيل المغادرة، نرسل إلى نزلائك استبيان تقييم عبر WhatsApp، مما يعزّز سمعة عقارك على الإنترنت بشكل كبير. وقد صُمّمت خدمتنا لزيادة تقييماتك الإيجابية.`,
    p67: `الدخول عن بُعد`,
    p68: `نرسل إلى نزلائك مفتاحًا افتراضيًا للدخول إلى العقار بشكل مستقل.`,
    p69: `المزايا`,
    p70: `سيتلقّى نزلاؤك مفاتيح دخول الغرف بأمان وسهولة بمجرد إتمام تسجيل الوصول، مما يمنحهم تجربة دون عناء ويحسّن كفاءة إدارة الدخول.`,
    p71: `التحقق من الهوية`,
    p72: `نتحقق من هوية نزلائك عبر برنامج المقارنة بالقياسات الحيوية لدينا.`,
    p73: `المزايا`,
    p74: `نتحقق من هوية نزلائك عبر برنامج المقارنة بالقياسات الحيوية لدينا، لنضمن تطابق مستنداتهم مع الشخص الذي يدخل وحدة إقامتك.`,
    p75: `اشترك الآن`,
    p76: `تخزين سحابي غير محدود`,
    p77: `مخصّص`,
    p78: `اسأل فريق المبيعات لدينا`,
    p79: `WhatsApp`,
    p80: `التحقق من الهوية`,
    p81: `التقييمات (تقييمات تسجيل الوصول)`,
    p82: `الاتصال بواجهة API للأقفال الذكية`,
    p83: `تحصيل من البطاقة (للودائع والخدمات وغيرها)`,
    p84: `تواصل مع المبيعات`,
    p85: ``,
    p86: ``,
    p87: ``,
    p88: ``,
    p89: ``,






};